/* eslint-disable */
/* react/no-array-index-key */
import React, { Component } from 'react';
import { withRouter } from 'utilities/withRouterWrapper';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Label, Input } from 'reactstrap';
import { TooltipStyled } from 'ui/TooltipStyled/TooltipStyled';
import Select from 'react-select';
import moment from 'moment-timezone';
import axios from 'axios';
import * as Utilities from 'utilities/utils';
import ConfirmationModal from 'common/ConfirmationModal';
import FilePopup from 'components/Files/FilePopup';
import { FILENAME } from 'utilities/regularexpressions';
import UploadFiles from 'api/UploadFiles';
import * as TaskApi from 'api/TaskApi';
import * as Config from 'constants/constants';
// import moment from 'moment';
import PdfViewer from 'components/PdfViewer/PdfViewer';
import mime from 'mime';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import MultipleSourceModal from 'components/Files/MultipleSourceModal';
import ManualSourceModal from 'components/Files/ManualSourceModal';
import ExportModal from '../Files/ExportModal';
import SharePointPicker from 'common/SharePoint/Picker';
import * as UploadFilesActions from 'actions/UploadFilesActions';
import './design.scss';
import DocumentPDFViewer from 'components/UploadedFiles/DocumentPDFViewer';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { withAISettings } from 'hooks/useAiFunctions/withAISettings';
import { AIFileNameManagement } from 'components/AI/AIFileNameManagement/AIFileNameManagement';
import { DeterministicFileNameManagement } from 'components/AI/DeterministicFileNameManagement/DeterministicFileNameManagement';
import { MutatingDot } from 'common/MutatingDot';
import { AITagManagement } from 'components/AI/AITagManagement/AITagManagement';
import { MarkAsReviewedConfirmationModal } from 'components/AI/MarkAsReviewedConfirmationModal/MarkAsReviewedConfirmationModal';
import { AlertMessage } from 'utilities/utils';
import ExportStatusSection from './ExportStatusSection';
import { Typography } from '@mui/material';
import { trackMixpanelEvent } from 'Mixpanel/mixpanelfn';
import { FileRenameCoachmark } from 'components/Onboarding/FileRenameCoachmark';
import {
  injectResourceHint,
  removeResourceHint,
} from 'utilities/resourceHints/resourceHints';

const timeZone =
  Intl.DateTimeFormat().resolvedOptions().timeZone || moment.tz.guess(true);
const isIE = /* @cc_on!@ */ false || !!document.documentMode;
const noneStyle = { display: 'none' };
const blockStyle = { display: 'block' };
const MANAGE_FILE_PANEL_STORAGE_KEY = 'documentShow.manageFilePanelCollapsed';

const readManageFilePanelCollapsed = () => {
  try {
    return (
      typeof window !== 'undefined' &&
      window.localStorage?.getItem(MANAGE_FILE_PANEL_STORAGE_KEY) === 'true'
    );
  } catch (_e) {
    return false;
  }
};
class DocumentShow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: true,
      filename: '',
      years: [],
      yearId: '',
      yearValue: '',
      selectedMultiTagRecords: [],
      mutiltagdropdownOpen: false,
      tags: [],
      tagId: '',
      tagName: '',
      inputMultiTagVal: '',
      newMultiTagList: [],
      loading: false,
      EditSubmit: false,
      editedTags: [],
      allAccounts: [],
      selectedAccount: '',
      editedYear: null,
      editedFileName: null,
      copied: false,
      tokenUrl: '',
      deleteConfirmation: false,
      fileExt: '',
      errors: {},
      months: [],
      monthId: '',
      monthValue: '',
      editedMonth: null,
      propState: {},
      updatedDownloadUrl: '',
      updatedFileUrl: '',
      filterStatusModal: false,
      filterStatus: 'active',
      shareFile: false,
      fileShared: false,
      newFileSource: '',
      selectedItem: {},
      exportModal: false,
      exportModalInitialApp: null,
      markAsReviewedModal: false,
      isPollingExportStatus: false,
      pollingAttempts: 0,
      pollingTimeoutId: null,
      sharePointPickerModal: false,
      // Navigation support for multi-document preview
      documents: [],
      currentIndex: 0,
      enableNavigation: false,
      // Context information - where user came from
      comingFrom: props.comingFrom || null,
      // AI processing status
      aiIngestionStatus: null,
      aiIngestionInProgress: false,
      // Optimistic-rename mirrors of DeterministicFileNameManagement state.
      // optimisticName overrides the header filename during the in-flight
      // window; isRenaming gates the two Download buttons (header + PSPDFKit
      // toolbar) so the user can't download a file whose Content-Disposition
      // name hasn't been committed server-side yet. Both clear in lockstep
      // with the mutation; see the renamed/accept callbacks below.
      optimisticName: null,
      isRenaming: false,
      isManageFilePanelCollapsed: readManageFilePanelCollapsed(),
      showFileRenameCoachmark: false,
      fileRenameSpotlightActive: false,
    };
    // LISD-2373: tracks <link rel="preconnect"|"preload"> elements appended
    // by componentDidMount + the initData success callback so we can remove
    // them in componentWillUnmount. Initialized here so callers can push
    // unconditionally without a defensive `||=`. _isMounted gates DOM-side
    // effects in async callbacks (initData's axios .then) that may resolve
    // after the component has been unmounted. _preloadHint holds the latest
    // preload <link> separately so initData refresh paths can replace it
    // instead of stacking duplicates.
    this._resourceHints = [];
    this._preloadHint = null;
    this._isMounted = false;
  }
  UNSAFE_componentWillMount() {
    if (
      this.props.location &&
      this.props.location.hash &&
      this.props.location.hash.indexOf('#multiple') > -1
    ) {
      this.setState({
        showMultipleSource: true,
      });
    }
  }

  /**
   * Initializes the component data.
   * moved code lines from componentDidMount
   * Supports both token-based and ID-based loading
   */
  initData() {
    const homeDataObj = Utilities.getStorageData();
    this.setState({ loading: true });

    // Support both token-based (PreviewFile) and ID-based (DocumentShow) loading
    const { token, uploadType, selectedItem } = this.props;

    let request;
    if (token) {
      // Token-based loading (from /document?token=... route or PreviewFile use case)
      const tokenParam = `?token=${token}&source=${uploadType || ''}`;
      request = axios.get(Config.SHOW_DOCUMENT_API_PATH + tokenParam);
    } else if (selectedItem && selectedItem.id) {
      // ID-based loading (current DocumentShow use case)
      request = axios.get(Config.GET_DOCUMENT_DETAILS + '/' + selectedItem.id);
    } else {
      console.error('DocumentShow: No token or selectedItem.id provided');
      this.setState({ loading: false });
      return;
    }

    request.then((res) => {
      if (res.status === 200 && res.data.data) {
        const removeDuplicateTags = Utilities.removeDuplicateTags(
          res.data.data.tags,
        );
        const documentData = res.data.data;
        documentData.tags = removeDuplicateTags;
        // LISD-2373: kick off the PDF byte download in parallel with the
        // remaining React mount + PSPDFKit init work. The browser caches the
        // response so PSPDFKit's eventual fetch is served from memory.
        // - _isMounted: skip if axios resolved after unmount (the new <link>
        //   would orphan in document.head — cleanup has already run).
        // - file_type === 'PDF': non-PDF docs render "click to download"
        //   inline, so preloading their bytes is pure waste (matches the
        //   backend's PDF-only direct-URL scoping in olympusapi).
        // - replace prior preload: initData() is reused on edit refresh
        //   (lines 974, 1027), so without this each refresh leaves a stale
        //   preload <link> in document.head until full unmount.
        if (
          this._isMounted &&
          documentData.file_url &&
          documentData.file_type === 'PDF'
        ) {
          if (this._preloadHint) {
            removeResourceHint(this._preloadHint);
            this._resourceHints = this._resourceHints.filter(
              (link) => link !== this._preloadHint,
            );
            this._preloadHint = null;
          }
          const link = injectResourceHint('preload', documentData.file_url, {
            as: 'fetch',
            crossOrigin: 'anonymous',
          });
          if (link) {
            this._preloadHint = link;
            this._resourceHints.push(link);
          }
        }
        const arhivedStatus = homeDataObj.is_employee
          ? documentData.is_file_archived_by_firm
          : documentData.is_file_archived_by_contact;
        const filterStatus = arhivedStatus ? 'archive' : 'active';
        const selectedItem = res.data.data;
        this.setState(
          {
            loading: false,
            yearId: selectedItem.upload_file_year,
            yearValue: selectedItem.upload_file_year,
            monthId: selectedItem.upload_file_month,
            monthValue: selectedItem.upload_file_month,
            token: selectedItem.file_download_url,
            selectedAccount: {
              label: selectedItem.account_name,
              value: selectedItem.account_id,
            },
            propState: selectedItem,
            filterStatus,
            selectedItem,
            aiIngestionStatus: selectedItem.ai_ingestion_status || null,
            aiIngestionInProgress:
              selectedItem.ai_ingestion_in_progress ?? false,
          },
          () => {
            if (this.state.comingFrom === 'onboarding') {
              setTimeout(() => {
                this.tryShowFileRenameCoachmark();
              }, 500);
            }
          },
        );
        const tagsData = homeDataObj.pref_type_options.upload_tags;
        const tagsCantAddRem = homeDataObj.is_employee
          ? homeDataObj.pref_type_options.tags_emp_cant_addrem
          : homeDataObj.pref_type_options.tags_client_cant_addrem;
        const selectedMultiTags = this.state.selectedMultiTagRecords;
        selectedItem.tags.map((item) => {
          if (tagsCantAddRem) {
            for (let j = 0; j < tagsCantAddRem.length; j += 1) {
              if (
                tagsCantAddRem[j].key &&
                tagsCantAddRem[j].key.toLowerCase() === item.toLowerCase()
              ) {
                selectedMultiTags.unshift({
                  tagId: tagsCantAddRem[j].key,
                  tagName: tagsCantAddRem[j].label,
                  closeIcon: false,
                });
              }
            }
          }
          if (tagsData) {
            for (let i = 0; i < tagsData.length; i += 1) {
              if (
                tagsData[i].key &&
                tagsData[i].key.toLowerCase() === item.toLowerCase()
              ) {
                selectedMultiTags.unshift({
                  tagId: tagsData[i].key,
                  tagName: tagsData[i].label,
                });
              }
            }
          }
          this.setState({ selectedMultiTagRecords: selectedMultiTags });
          return null;
        });
        this.fileExtention(selectedItem.doc_name);
        const contactId = selectedItem.contact_id;
        if (contactId) {
          TaskApi.AccountsOfContact(this, contactId);
        }
      }
    });
  }

  componentDidMount() {
    this._isMounted = true;
    // LISD-2373: warm the TCP+TLS handshake to the file storage origin so
    // PSPDFKit's PDF fetch later in the load sequence doesn't pay for
    // connection setup. _resourceHints is initialized in the constructor;
    // cleanup happens in componentWillUnmount.
    const vaultHost = import.meta.env.VITE_VAULT_HOST;
    if (vaultHost) {
      const link = injectResourceHint('preconnect', vaultHost, {
        crossOrigin: 'anonymous',
      });
      if (link) this._resourceHints.push(link);
    }

    // Initialize navigation state from props if provided
    const { documents, currentIndex, enableNavigation } = this.props;
    if (documents && documents.length > 0) {
      this.setState({
        documents: documents,
        currentIndex: currentIndex || 0,
        enableNavigation: enableNavigation || false,
      });
    }

    // Initialize years, months, and tags for edit mode (since we're always in edit mode now)
    const homeDataObj = Utilities.getStorageData();
    const yearsOptions =
      this.props.years ||
      homeDataObj?.pref_type_options?.upload_file_year ||
      [];
    const monthsOptions =
      this.props.months ||
      homeDataObj?.pref_type_options?.upload_file_month ||
      [];
    const tagsOptions =
      this.props.tags || homeDataObj?.pref_type_options?.upload_tags || [];
    this.setState({
      years: yearsOptions,
      months: monthsOptions,
      tags: tagsOptions,
      newMultiTagList: tagsOptions,
    });

    if (
      this.props.comingFrom === 'onboarding' &&
      this.state.isManageFilePanelCollapsed
    ) {
      this.setState({ isManageFilePanelCollapsed: false });
    }

    this.initData();
  }

  shouldShowFileRenameCoachmark = () => {
    if (this.state.comingFrom !== 'onboarding') return false;
    if (!this.props.flags?.enableFileDeterministicNaming) return false;
    if (!Utilities.isUserEmployee()) return false;
    const item = this.state.selectedItem;
    if (!item?.uuid || !item?.suggested_name || item?.auto_named) return false;
    return true;
  };

  tryShowFileRenameCoachmark = () => {
    if (!this._isMounted || !this.shouldShowFileRenameCoachmark()) return;
    this.setState({ showFileRenameCoachmark: true });
  };

  handleFileRenameCoachmarkDismiss = () => {
    this.setState({
      showFileRenameCoachmark: false,
      fileRenameSpotlightActive: false,
    });
  };

  handleFileRenameCoachmarkSpotlight = () => {
    this.setState({
      showFileRenameCoachmark: false,
      fileRenameSpotlightActive: true,
    });
  };

  componentWillUnmount() {
    this._isMounted = false;
    // Clean up polling when component unmounts
    this.stopExportStatusPolling();
    // LISD-2373: drop any preconnect/preload <link> elements we appended.
    this._resourceHints.forEach((link) => removeResourceHint(link));
    this._resourceHints = [];
    this._preloadHint = null;
  }

  // Navigation methods for multi-document preview
  toggleManageFilePanel = () => {
    this.setState(
      (prev) => ({ isManageFilePanelCollapsed: !prev.isManageFilePanelCollapsed }),
      () => {
        try {
          window.localStorage?.setItem(
            MANAGE_FILE_PANEL_STORAGE_KEY,
            String(this.state.isManageFilePanelCollapsed),
          );
        } catch (_e) {
          /* localStorage may be unavailable (private mode); collapse still works for the session */
        }
      },
    );
  };

  handleNextDocument = () => {
    const { currentIndex, documents } = this.state;
    if (currentIndex < documents.length - 1) {
      const nextIndex = currentIndex + 1;
      this.setState({ currentIndex: nextIndex });
      this.loadDocumentByIndex(nextIndex);
    }
  };

  handlePreviousDocument = () => {
    const { currentIndex } = this.state;
    if (currentIndex > 0) {
      const prevIndex = currentIndex - 1;
      this.setState({ currentIndex: prevIndex });
      this.loadDocumentByIndex(prevIndex);
    }
  };

  loadDocumentByIndex = (index) => {
    const { documents } = this.state;
    const { token, onNavigate } = this.props;
    const doc = documents[index];

    if (onNavigate) {
      // Notify parent component of navigation
      onNavigate(index);
    }

    // Reload with new document
    if (token) {
      // Token-based navigation - re-fetch with new token
      const homeDataObj = Utilities.getStorageData();
      const { uploadType } = this.props;
      this.setState({ loading: true });

      const tokenParam = `?token=${doc.file_share_url}&source=${
        uploadType || ''
      }`;
      const request = axios.get(Config.SHOW_DOCUMENT_API_PATH + tokenParam);

      request
        .then((res) => {
          if (res.status === 200 && res.data.data) {
            const removeDuplicateTags = Utilities.removeDuplicateTags(
              res.data.data.tags,
            );
            const documentData = res.data.data;
            documentData.tags = removeDuplicateTags;
            const arhivedStatus = homeDataObj.is_employee
              ? documentData.is_file_archived_by_firm
              : documentData.is_file_archived_by_contact;
            const filterStatus = arhivedStatus ? 'archive' : 'active';
            this.setState({
              loading: false,
              selectedItem: documentData,
              propState: documentData,
              filterStatus,
            });
          }
        })
        .catch((error) => {
          console.error('Error loading document:', error);
          this.setState({ loading: false });
        });
    }
  };

  onMultiTagFocus = () => {
    this.setState((prevState) => ({
      mutiltagdropdownOpen: true,
      tags: prevState.tags,
      tagId: '',
      tagName: '',
    }));
    if (this.state.errors.tags) {
      const err = this.state.errors;
      err.tags = '';
      this.setState({ errors: err });
    }
  };
  getInitials(name) {
    if (name === undefined) {
      return null;
    }
    const initials =
      (name.split(' ')[0] ? name.split(' ')[0].charAt(0) : '') +
      (name.split(' ')[1] ? name.split(' ')[1].charAt(0) : '');
    return initials;
  }

  refreshDocumentDetails = () => {
    // Refresh the document details to get updated export status
    const request = axios.get(
      Config.GET_DOCUMENT_DETAILS + '/' + this.props.selectedItem.id,
    );
    request
      .then((res) => {
        if (res.status === 200 && res.data.data) {
          const removeDuplicateTags = Utilities.removeDuplicateTags(
            res.data.data.tags,
          );
          const documentData = res.data.data;
          documentData.tags = removeDuplicateTags;

          // Update the selectedItem with fresh data including export status
          this.setState({
            selectedItem: documentData,
            propState: documentData,
          });
        }
      })
      .catch((error) => {
        console.error('Failed to refresh document details:', error);
      });
  };

  startExportStatusPolling = () => {
    // Prevent multiple polling sessions
    if (this.state.isPollingExportStatus) {
      return;
    }

    // Clear any existing timeout
    if (this.state.pollingTimeoutId) {
      clearTimeout(this.state.pollingTimeoutId);
    }

    // Start polling after 5 seconds to allow export process to begin
    const timeoutId = setTimeout(() => {
      this.setState({
        isPollingExportStatus: true,
        pollingAttempts: 0,
        pollingTimeoutId: null,
      });
      this.pollExportStatus();
    }, 5000);

    this.setState({ pollingTimeoutId: timeoutId });
  };

  pollExportStatus = () => {
    const { isPollingExportStatus, pollingAttempts } = this.state;

    // Stop polling if we've reached the limit or polling was stopped
    if (!isPollingExportStatus || pollingAttempts >= 10) {
      this.setState({
        isPollingExportStatus: false,
        pollingAttempts: 0,
        pollingTimeoutId: null,
      });
      return;
    }

    // Make the API call to check for updated export status
    const request = axios.get(
      Config.GET_DOCUMENT_DETAILS + '/' + this.props.selectedItem.id,
    );

    request
      .then((res) => {
        if (res.status === 200 && res.data.data) {
          const removeDuplicateTags = Utilities.removeDuplicateTags(
            res.data.data.tags,
          );
          const documentData = res.data.data;
          documentData.tags = removeDuplicateTags;

          // Update the selectedItem with fresh data
          this.setState({
            selectedItem: documentData,
            propState: documentData,
            pollingAttempts: pollingAttempts + 1,
          });

          // Check if export status has been updated
          const sharepointStatus = documentData.export_statuses?.sharepoint;
          const zapierStatus = documentData.export_statuses?.zapier;

          // Stop polling if either export is completed (exported or failed)
          // Only check status if it exists (was being exported)
          const sharepointComplete =
            sharepointStatus &&
            (sharepointStatus.status === 'exported' ||
              sharepointStatus.status === 'export_failed');
          const zapierComplete =
            zapierStatus &&
            (zapierStatus.status === 'exported' ||
              zapierStatus.status === 'export_failed');

          // If we were polling and at least one export is complete, stop polling
          // Also stop if we've been polling for a while and neither export is in progress
          const sharepointInProgress =
            sharepointStatus && sharepointStatus.status === 'exporting';
          const zapierInProgress =
            zapierStatus && zapierStatus.status === 'exporting';
          const anyExportInProgress = sharepointInProgress || zapierInProgress;

          if (this.state.isPollingExportStatus) {
            if (sharepointComplete || zapierComplete) {
              // Export completed (success or failure), stop polling
              this.setState({
                isPollingExportStatus: false,
                pollingAttempts: 0,
                pollingTimeoutId: null,
              });
              return;
            }

            // If no export is in progress and we've polled a few times, stop polling
            if (!anyExportInProgress && pollingAttempts >= 3) {
              this.setState({
                isPollingExportStatus: false,
                pollingAttempts: 0,
                pollingTimeoutId: null,
              });
              return;
            }
          }

          // Continue polling after 5 seconds
          const timeoutId = setTimeout(() => {
            this.pollExportStatus();
          }, 5000);

          this.setState({ pollingTimeoutId: timeoutId });
        }
      })
      .catch((error) => {
        console.error('Failed to poll export status:', error);
        // Continue polling even on error, but increment attempts
        this.setState({ pollingAttempts: pollingAttempts + 1 });

        // Continue polling after 5 seconds
        const timeoutId = setTimeout(() => {
          this.pollExportStatus();
        }, 5000);

        this.setState({ pollingTimeoutId: timeoutId });
      });
  };

  stopExportStatusPolling = () => {
    // Clear any pending timeout
    if (this.state.pollingTimeoutId) {
      clearTimeout(this.state.pollingTimeoutId);
    }

    this.setState({
      isPollingExportStatus: false,
      pollingAttempts: 0,
      pollingTimeoutId: null,
    });
  };
  accountChange = (val) => {
    const { propState, errors } = this.state;
    const err = {};
    if (
      propState.source.toLowerCase() === 'manual' &&
      !propState.contact_id &&
      !val
    ) {
      err.account = 'Account is mandatory as no contact is tied to this file';
      this.setState({
        errors: err,
      });
      return false;
    }
    this.setState({
      selectedAccount: val || { label: '', value: '' },
      errors: {},
    });
  };
  fileExtention(item) {
    let m;
    let filenm = item;
    if (item.includes('.')) {
      const n = item.split('.').pop();
      m = '.' + n;
      filenm = item.substring(0, item.lastIndexOf('.'));
    } else {
      m = '';
    }
    this.setState({ fileExt: m, filename: filenm });
  }
  handleMultiTagChange = (val) => {
    const tagsArr = this.state.tags;
    const component = this;
    if (val) {
      component.setState({ tagId: val.key, tagName: val.label, errors: {} });
    } else {
      component.setState({ tagId: '', tagName: '', errors: {} });
    }

    const selectedInput = {
      tagId: val.key,
      tagName: val.label,
    };
    const selectedRecordsArr = this.state.selectedMultiTagRecords;
    const index = selectedRecordsArr.findIndex(
      (x) => x.tagId === selectedInput.tagId,
    );
    if (index === -1) {
      selectedRecordsArr.push(selectedInput);
      this.setState({ selectedMultiTagRecords: selectedRecordsArr });
    }
    this.setState({
      mutiltagdropdownOpen: false,
      tags: tagsArr,
      newMultiTagList: tagsArr,
      tagId: '',
      tagName: '',
    });
  };
  filterMultiTagSearch = (target) => {
    if (target) {
      const k = [];
      const value = target;
      const filter = value.toUpperCase();
      const tags = this.state.tags;
      tags.map((tag) => {
        for (let i = 0; i < target.length; i += 1) {
          if (tag.label.toUpperCase().indexOf(filter) > -1) {
            if (k.indexOf(tag) === -1) {
              k.push(tag);
            }
          }
        }
        return k;
      });
      this.setState({ newMultiTagList: k });
    } else {
      this.setState({ newMultiTagList: this.state.tags });
    }
  };
  handleEditDocumentCancel = () => {
    const component = this;
    // TODO: __HOMEDATA-AUDIT
    const homeDataObj = Utilities.getStorageData();
    const tagsData = homeDataObj.pref_type_options.upload_tags;
    const tagsCantAddRem = homeDataObj.is_employee
      ? homeDataObj.pref_type_options.tags_emp_cant_addrem
      : homeDataObj.pref_type_options.tags_client_cant_addrem;
    component.setState({
      loading: false,
      mutiltagdropdownOpen: false,
      errors: {},
      newMultiTagList: this.state.tags,
    });
    if (!this.state.EditSubmit) {
      let tagg = [];
      const selectedMultiTags = [];
      if (component.state.editedTags.length > 0) {
        component.state.editedTags.map((item) => {
          for (let j = 0; j < tagsCantAddRem.length; j += 1) {
            if (tagsCantAddRem[j].key === item) {
              selectedMultiTags.unshift({
                tagId: tagsCantAddRem[j].key,
                tagName: tagsCantAddRem[j].label,
                closeIcon: false,
              });
            }
          }
          for (let i = 0; i < tagsData.length; i += 1) {
            if (tagsData[i].key === item) {
              selectedMultiTags.unshift({
                tagId: tagsData[i].key,
                tagName: tagsData[i].label,
              });
            }
          }
          tagg = selectedMultiTags;
          return null;
        });
      } else {
        component.state.selectedItem.tags.map((item) => {
          for (let j = 0; j < tagsCantAddRem.length; j += 1) {
            if (tagsCantAddRem[j].key === item) {
              selectedMultiTags.unshift({
                tagId: tagsCantAddRem[j].key,
                tagName: tagsCantAddRem[j].label,
                closeIcon: false,
              });
            }
          }
          for (let i = 0; i < tagsData.length; i += 1) {
            if (tagsData[i].key === item) {
              selectedMultiTags.unshift({
                tagId: tagsData[i].key,
                tagName: tagsData[i].label,
              });
            }
          }
          tagg = selectedMultiTags;
          return null;
        });
      }
      let yearr = null;
      if (component.state.editedYear !== null) {
        yearr = component.state.editedYear;
      } else {
        yearr = component.state.selectedItem.upload_file_year;
      }
      let monthh = null;
      if (component.state.editedMonth !== null) {
        monthh = component.state.editedMonth;
      } else {
        monthh = component.state.selectedItem.upload_file_month;
      }
      if (component.state.editedFileName !== null) {
        component.fileExtention(component.state.editedFileName);
      } else {
        component.fileExtention(component.state.selectedItem.doc_name);
      }
      component.setState({
        selectedMultiTagRecords: tagg,
        yearId: yearr,
        yearValue: yearr,
        monthId: monthh,
        monthValue: monthh,
        selectedAccount: {
          label: component.state.selectedItem.account_name,
          value: component.state.selectedItem.account_id,
        },
      });
    } else {
      let tagg = [];
      if (component.state.editedTags.length > 0) {
        const selectedMultiTags = [];
        component.state.editedTags.map((item) => {
          for (let j = 0; j < tagsCantAddRem.length; j += 1) {
            if (tagsCantAddRem[j].key === item) {
              selectedMultiTags.unshift({
                tagId: tagsCantAddRem[j].key,
                tagName: tagsCantAddRem[j].label,
                closeIcon: false,
              });
            }
          }
          for (let i = 0; i < tagsData.length; i += 1) {
            if (tagsData[i].key === item) {
              selectedMultiTags.unshift({
                tagId: tagsData[i].key,
                tagName: tagsData[i].label,
              });
            }
          }
          tagg = selectedMultiTags;
          return null;
        });
      }
      component.fileExtention(component.state.editedFileName);
      component.setState({
        selectedMultiTagRecords: tagg,
        yearId: component.state.editedYear,
        yearValue: component.state.editedYear,
        monthId: component.state.editedMonth,
        monthValue: component.state.editedMonth,
        selectedAccount: {
          label: component.state.propState.account_name,
          value: component.state.propState.account_id,
        },
      });
    }
  };
  handleEditDocumentSubmit = (e) => {
    e.preventDefault();
    const validation = this.handleValidation();
    if (validation.isValid) {
      const tagg = [];
      this.state.selectedMultiTagRecords.map((tag) => {
        return tagg.push(tag.tagId);
      });
      const mydata = {
        multi_tags: tagg,
        document_ids: this.state.selectedItem.id,
        year: this.state.yearId,
        month: this.state.monthId,
        file_name: this.state.filename + this.state.fileExt,
        account_id: this.state.selectedAccount
          ? this.state.selectedAccount.value
          : '',
      };
      UploadFiles.updateSingleFile(mydata, this);
    } else {
      // Show validation error messages to the user
      const { errors } = validation;
      if (errors.filename) {
        AlertMessage('error', errors.filename, 3000);
      } else if (errors.tags) {
        AlertMessage('error', errors.tags, 3000);
      }
    }
  };
  changeMultiTagInput = () => {
    return false;
  };
  downloadAttachement(url) {
    // PDFs go through DocumentPDFViewer's download coordinator so the user
    // gets the with/without-annotations choice when annotations exist; non-PDF
    // files (and legacy IE where PSPDFKit isn't loaded) download directly.
    const instance = window.PSPDFKIT_INSTANCE;
    if (instance && typeof instance.exportPDF === 'function') {
      window.dispatchEvent(
        new CustomEvent('liscio:pdf-download-requested', {
          detail: { originalUrl: url },
        }),
      );
      return;
    }
    window.location.href = url;
  }
  handleYearChange = (val) => {
    const component = this;
    if (val) {
      component.setState({
        yearId: parseInt(val.key, 10),
        yearValue: val.label,
        errors: {},
      });
    } else {
      component.setState({ yearId: '', yearValue: '', errors: {} });
    }
  };
  handleMonthChange = (val) => {
    const component = this;
    if (val) {
      component.setState({
        monthId: val.key,
        monthValue: val.label,
        errors: {},
      });
    } else {
      component.setState({ monthId: '', monthValue: '', errors: {} });
    }
  };
  removeSelectedMultiTagRecord = (tagId) => {
    const selectedRecordsArr = this.state.selectedMultiTagRecords;
    const index = selectedRecordsArr.findIndex((x) => x.tagId === tagId);
    if (index > -1) {
      selectedRecordsArr.splice(index, 1);
      this.setState({ selectedMultiTagRecords: selectedRecordsArr });
    }
  };
  showCopy = () => {
    this.setState({ copied: true });
    setTimeout(() => {
      this.setState({ copied: false });
    }, 3000);
  };
  deleteConfirmationModal = (act = '') => {
    if (act === 'delete') {
      UploadFiles.DeleteDocument(this.state.selectedItem, this);
    } else if (act === 'filterstatus') {
      const { filterStatus } = this.state;
      const ids = [];
      ids.push(this.state.selectedItem.id);
      const data = {
        id: ids,
      };
      if (filterStatus === 'active') {
        data.archive = 'true';
      }
      UploadFiles.archiveFile(this, data, 'previewFile');
    }
  };
  genLink = () => {
    const url =
      window.location.protocol +
      '//' +
      window.location.host +
      '/document?token=' +
      this.state.selectedItem.file_share_url;
    return url;
  };
  handleInputFieldChange = (e) => {
    const fieldName = e.target.name;
    const fieldValue = e.target.value;

    // Clear error for this field when user starts typing
    this.setState((prevState) => ({
      [fieldName]: fieldValue,
      errors: {
        ...prevState.errors,
        [fieldName]: '',
      },
    }));
  };
  handleChangeFileName = (updatedFile) => {
    if (this.props.component?.dataAfterEditDocument) {
      this.props.component.dataAfterEditDocument();
    }

    // If we have updated file data, update the selectedItem immediately
    if (updatedFile) {
      // Map the API response fields to match our selectedItem structure
      const updatedSelectedItem = {
        ...this.state.selectedItem,
        ...updatedFile,
        // Ensure all possible filename fields are mapped correctly
        file_name: updatedFile.display_name,
        doc_name: updatedFile.doc_name || updatedFile.display_name,
      };

      // Extract filename and extension to update state (same logic as fileExtention)
      const updatedFileName = updatedFile.doc_name || updatedFile.display_name;
      let fileExt = '';
      let filename = updatedFileName;
      if (updatedFileName && updatedFileName.includes('.')) {
        const extension = updatedFileName.split('.').pop();
        fileExt = '.' + extension;
        filename = updatedFileName.substring(
          0,
          updatedFileName.lastIndexOf('.'),
        );
      }

      this.setState({
        selectedItem: updatedSelectedItem,
        editedFileName: updatedFileName, // Track for parent component
        filename: filename, // Update filename state for metadata form
        fileExt: fileExt, // Update fileExt state for metadata form
      });

      // Don't reload data to prevent breaking the file preview
      AlertMessage('success', 'Document name updated successfully', 3000);
    } else {
      // For legacy file rename operations, reload data
      this.initData();
      AlertMessage('success', 'Document name updated successfully', 3000);
    }
  };
  convertTagKeysToSelectedMultiTagRecords = (tagKeys) => {
    // Convert array of tag keys (strings) to selectedMultiTagRecords format (objects)
    // TODO: __HOMEDATA-AUDIT
    const homeDataObj = Utilities.getStorageData();
    const tagsData = homeDataObj.pref_type_options.upload_tags || [];
    const tagsCantAddRem = homeDataObj.is_employee
      ? homeDataObj.pref_type_options.tags_emp_cant_addrem || []
      : homeDataObj.pref_type_options.tags_client_cant_addrem || [];
    const selectedMultiTags = [];

    for (const tagKey of tagKeys) {
      const normalizedKey = tagKey.toLowerCase();

      // Check restricted tags first (they take priority)
      const restrictedTag = tagsCantAddRem.find(
        (tag) => tag.key && tag.key.toLowerCase() === normalizedKey,
      );

      if (restrictedTag) {
        selectedMultiTags.push({
          tagId: restrictedTag.key,
          tagName: restrictedTag.label,
          closeIcon: false,
        });
        continue;
      }

      // Check regular tags
      const regularTag = tagsData.find(
        (tag) => tag.key && tag.key.toLowerCase() === normalizedKey,
      );

      if (regularTag) {
        selectedMultiTags.push({
          tagId: regularTag.key,
          tagName: regularTag.label,
        });
      }
    }

    return selectedMultiTags;
  };

  handleChangeTags = (newTags) => {
    if (this.props.component?.dataAfterEditDocument) {
      this.props.component.dataAfterEditDocument();
    }

    if (!newTags || !Array.isArray(newTags)) {
      this.initData();
      AlertMessage('success', 'Tags updated successfully', 3000);
      return;
    }

    // Update selectedItem with new tags
    const updatedSelectedItem = {
      ...this.state.selectedItem,
      tags: newTags,
    };

    // Update selectedMultiTagRecords to prevent metadata save from reverting tag changes
    const selectedMultiTagRecords =
      this.convertTagKeysToSelectedMultiTagRecords(newTags);

    this.setState({
      selectedItem: updatedSelectedItem,
      editedTags: newTags,
      selectedMultiTagRecords,
    });

    AlertMessage('success', 'Tags updated successfully', 3000);
  };
  handleValidation() {
    const filename = this.state.filename;
    const err = {};
    let formIsValid = true;
    if (!filename) {
      formIsValid = false;
      err.filename = 'Please enter document name';
    } else if (filename && !FILENAME.test(filename)) {
      formIsValid = false;
      err.filename =
        'File name contains invalid characters. Use only letters, numbers, and basic symbols';
    }
    // if (this.state.selectedMultiTagRecords.length <= 0) {
    //   formIsValid = false;
    //   err.tags = 'At least 1 tag is mandatory';
    // }
    this.setState({ errors: err });
    return { isValid: formIsValid, errors: err };
  }
  confirmDeletion = () => {
    const { source } = this.state.selectedItem;
    if (source === 'Multiple') {
      this.setState({
        deleteConfirmation: true,
        deleteAlertMessage:
          'Warning: The selected files will be deleted from all sources i.e Messages, Tasks etc.',
      });
    } else {
      this.setState({
        deleteConfirmation: true,
        deleteAlertMessage: 'Are you sure you want to delete this file?',
      });
    }
  };
  shareFile = () => {
    this.setState({
      shareFile: true,
    });
  };
  closeModal = (ishared = '', uniqueRecords = '') => {
    this.setState({ shareFile: false });
    if (ishared === 'shared' && uniqueRecords.length > 0) {
      const token = this.state.selectedItem.file_share_url;
      UploadFiles.particularDocumentData(this, token);
    }
  };
  renderMultiTags = () => {
    const selectedMultiTagRecords = this.state.selectedMultiTagRecords.map(
      (item) => {
        if (item.tagId) {
          return (
            <span className="tag tag--fill" key={item.tagId}>
              {item.tagName}
              {item.closeIcon === false ? null : (
                <i
                  className="icon-close2 remove"
                  onClick={() => this.removeSelectedMultiTagRecord(item.tagId)}
                />
              )}
            </span>
          );
        }
        return (
          <span className="tag tag--fill" key={item.tagId}>
            {item.tagName}{' '}
            {item.closeIcon === false ? null : (
              <i
                className="icon-close2 remove"
                onClick={() => this.removeSelectedMultiTagRecord(item.tagId)}
              />
            )}
          </span>
        );
      },
    );
    return selectedMultiTagRecords;
  };
  redirectLink = (item) => {
    const { navigate } = this.props;
    if (
      (item.source.toLowerCase() === 'task' ||
        item.source.toLowerCase() === 'bill') &&
      item.link !== undefined &&
      item.link !== null
    ) {
      if (Utilities.getFirmType() === 'liscio-lite') {
        this.setState({
          showAlert:
            'Associated Task cannot be viewed. Please upgrade to LiscioPRO',
        });
      } else {
        this.props.files.previewFile(item, true);
        navigate(`/task/detail/${item.link}`, {
          state: { from: 'uploadlist' },
        });
      }
    } else if (
      item.source.toLowerCase() === 'message' &&
      item.link !== undefined &&
      item.link !== null
    ) {
      this.props.files.previewFile(item, true);
      const id = encodeURIComponent(item.link);
      navigate(`/inbox/${id}`, { state: { from: 'uploadlist' } });
    } else if (
      item.source.toLowerCase() === 'note' &&
      item.link !== undefined &&
      item.link !== null
    ) {
      if (Utilities.getFirmType() === 'liscio-lite') {
        this.setState({
          showAlert:
            'Associated Note cannot be viewed. Please upgrade to LiscioPRO',
        });
      } else {
        this.props.files.previewFile(item, true);
        navigate(`/notedetails/${item.link}`, {
          state: { from: 'uploadlist' },
        });
      }
    } else if (
      item.source === 'Multiple' ||
      ((item.source.toLowerCase() === 'message' ||
        item.source.toLowerCase() === 'note' ||
        item.source.toLowerCase() === 'task') &&
        item.link === null)
    ) {
      // do nothing
      this.props.files.previewFile(item, true);
      this.setState({
        showMultipleSource: true,
      });
      const { location } = this.props;
      const { hash } = location;
      if (hash && hash.indexOf('#files') > -1) {
        navigate(location.pathname + '#files#multiple-' + item.id);
      }
      if (location.pathname.includes('/accountdetails')) {
        navigate(`${location.pathname}#multiple-${item.id}`);
      } else {
        navigate('/files#multiple-' + item.id);
      }
    } else if (item.source === 'Manual') {
      this.setState({
        fileDetails: item,
        showManualSource: true,
      });
    }
  };
  closeRedirectModal = (source, index) => {
    this.setState(
      {
        [source]: false,
      },
      () => {
        const { location, navigate } = this.props;
        const { hash } = location;
        if (index && index === true) {
          const { hash } = location;
          if (hash && hash.indexOf('#multiple') > -1) {
            navigate(location.pathname);
          }
          // this.props.component.uploadFile('close');
        } else {
          if (hash && hash.indexOf('#files') > -1) {
            navigate(location.pathname + '#files');
          }
          if (
            hash &&
            hash.indexOf('#multiple') > -1 &&
            location.pathname.includes('/accountdetails')
          ) {
            navigate(location.pathname);
          } else {
            navigate('/files');
          }
        }
      },
    );
  };

  closeAction = () => {
    // Pass edited data back to parent component so it can update its local state
    const hasChanges = this.state.editedFileName || this.state.editedTags;
    const dataToReturn = hasChanges
      ? {
          editedFileName: this.state.editedFileName,
          editedTags: this.state.editedTags,
          selectedItem: this.state.selectedItem,
        }
      : undefined;

    const updateParam = dataToReturn
      ? {
          ...dataToReturn,
          shouldUpdate: true,
        }
      : this.state.updateFileListData || hasChanges;

    this.props.onButtonClose(null, updateParam, this.props);
  };

  handleButtonCloseClick = () => {
    const isAiTaggingEnabled =
      this.props.aiSettings.isAiEnabled && this.props.flags.enableAiTagging;
    const isAiRenamingEnabled =
      this.props.aiSettings.isAiEnabled &&
      this.props.flags.enableAiFileRenaming;

    const shouldShowAiReviewModal =
      this.state.selectedItem.pending_review &&
      (isAiTaggingEnabled || isAiRenamingEnabled);

    if (shouldShowAiReviewModal) {
      this.setState({ markAsReviewedModal: true });
    } else {
      this.closeAction();
    }
  };

  handleDashboardClick = () => {
    // Track Mixpanel event for dashboard navigation from onboarding
    if (Utilities.isUserEmployee()) {
      const homeData = Utilities.getStorageData();
      trackMixpanelEvent('dashboard_viewed', {
        user_role: 'firm_employee',
        company_name: homeData?.userpilot_data?.firm_name,
        onboarding_step: 'dashboard_viewed',
      });
    }

    // Navigate to dashboard
    this.props.navigate('/dashboard');
  };

  render() {
    const {
      propState,
      errors,
      newMultiTagList,
      editedTags,
      loading,
      EditSubmit,
      updatedDownloadUrl,
      editedFileName,
      copied,
      filename,
      allAccounts,
      selectedAccount,
      inputMultiTagVal,
      tagId,
      tagName,
      years,
      yearId,
      yearValue,
      editedYear,
      months,
      monthId,
      monthValue,
      editedMonth,
      deleteConfirmation,
      updatedFileUrl,
      filterStatusModal,
      markAsReviewedModal,
      filterStatus,
      fileShared,
      uniqueRecords,
      newFileSource,
      updateFileListData,
      selectedItem,
      fileDetails,
    } = this.state;
    // const { selectedItem } = this.props;
    const multiTags =
      newMultiTagList &&
      newMultiTagList.map((item) => {
        return (
          <a
            key={item.key}
            onClick={() => this.handleMultiTagChange(item)}
            href="javascript:void(0)"
            className="dropdown-item"
          >
            {item.label}
          </a>
        );
      });
    let oldTags = '';
    if (selectedItem.tags !== undefined) {
      oldTags = selectedItem.tags.map((item) => {
        return (
          <span className="tag tag--fill" key={item}>
            {Utilities.tagLabel(item)}
          </span>
        );
      });
    }
    const newTags = editedTags.map((item) => {
      return (
        <span className="tag tag--fill" key={item}>
          {Utilities.tagLabel(item)}
        </span>
      );
    });
    if (loading) {
      return (
        <div
          id="loading"
          style={loading ? blockStyle : noneStyle}
          role="status"
          aria-label="Loading DocumentShow"
        />
      );
    }
    const getSize = selectedItem.file_size / 1024;
    const trimSize = getSize.toFixed(2);
    const dateAdded = moment
      .tz(selectedItem.date_created, timeZone)
      .format('MM/DD/YYYY');
    // TODO: __HOMEDATA-AUDIT
    const storageData = Utilities.getStorageData();
    const url = EditSubmit
      ? updatedDownloadUrl
      : selectedItem.file_download_url;
    const fileUrl = EditSubmit ? updatedFileUrl : selectedItem.file_url;
    let recepent = selectedItem.recipient;
    let source = selectedItem.source;
    if (fileShared) {
      recepent = uniqueRecords;
      source = newFileSource;
    }

    const isAiTaggingEnabled =
      this.props.aiSettings.isAiEnabled && this.props.flags.enableAiTagging;
    const isAiRenamingEnabled =
      this.props.aiSettings.isAiEnabled &&
      this.props.flags.enableAiFileRenaming;
    const isDeterministicNamingEnabled =
      this.props.flags?.enableFileDeterministicNaming === true;

    return (
      <div className="eng-letter">
        <header>
          <div className="headerWrapper row">
            <div className="left-side col-md-8 col-12">
              <Button
                className="btn-link btn--onlyicon btn btn-secondary"
                onClick={this.handleButtonCloseClick}
              >
                <i className="icon-back-arrow" aria-hidden="true" />
              </Button>
              <div className="head-inner d-block">
                <h2>
                  {this.state.optimisticName
                    ?? (EditSubmit ? editedFileName : selectedItem.doc_name)}
                  {this.state.isRenaming && <MutatingDot />}
                  {selectedItem.is_private && (
                    <i className="icon-Lock text-dark ml-1" />
                  )}
                </h2>
                <h5>
                  Modified on{' '}
                  {moment
                    .tz(selectedItem.date_created, timeZone)
                    .format('MMM Do YYYY')}
                </h5>
              </div>
              {/* Navigation controls for multi-document preview */}
              {this.state.enableNavigation && this.state.documents.length > 1 && (
                <div className="document-navigation d-flex align-items-center mt-2">
                  <Button
                    color="secondary"
                    size="sm"
                    onClick={this.handlePreviousDocument}
                    disabled={this.state.currentIndex === 0}
                    className="mr-2"
                  >
                    <i className="icon-chevron-left" aria-hidden="true" />{' '}
                    Previous
                  </Button>
                  <span className="text-muted mx-2">
                    {this.state.currentIndex + 1} of{' '}
                    {this.state.documents.length}
                  </span>
                  <Button
                    color="secondary"
                    size="sm"
                    onClick={this.handleNextDocument}
                    disabled={
                      this.state.currentIndex ===
                      this.state.documents.length - 1
                    }
                    className="ml-2"
                  >
                    Next <i className="icon-chevron-right" aria-hidden="true" />
                  </Button>
                </div>
              )}
            </div>
            <div className="right-side col-md-4 col-12">
              <div className="btn-wrap btn--leftspace">
                <CopyToClipboard
                  text={
                    window.location.protocol +
                    '//' +
                    window.location.host +
                    '/document?token=' +
                    selectedItem.file_share_url
                  }
                  onCopy={this.showCopy}
                >
                  <Button
                    className="btn btn-outline-light"
                    onClick={this.genLink}
                  >
                    {copied ? 'Copied' : 'Copy link'}
                  </Button>
                </CopyToClipboard>
                <TooltipStyled
                  title={filterStatus === 'archive' ? 'Unarchive' : 'Archive'}
                >
                  <span>
                    <Button
                      className="btn-link btn--onlyicon btn btn-secondary"
                      onClick={() => this.setState({ filterStatusModal: true })}
                    >
                      <i
                        className={
                          filterStatus === 'archive'
                            ? 'icon-unarchive'
                            : 'icon-archive-line'
                        }
                        aria-hidden="true"
                      />
                    </Button>
                  </span>
                </TooltipStyled>
                <TooltipStyled
                  title={
                    this.state.isRenaming ? 'Saving rename…' : 'Download'
                  }
                >
                  <span>
                    <Button
                      className="btn-link btn--onlyicon btn btn-secondary"
                      onClick={() => this.downloadAttachement(url)}
                      disabled={this.state.isRenaming}
                    >
                      <i className="icon-download2" aria-hidden="true" />
                    </Button>
                  </span>
                </TooltipStyled>
                <TooltipStyled title="Export">
                  <span>
                    <Button
                      className="btn-link btn--onlyicon btn btn-secondary"
                      onClick={() => this.setState({ exportModal: true })}
                      data-testid="files__icon-upload"
                    >
                      <i className="icon-upload" />
                    </Button>
                  </span>
                </TooltipStyled>
                {Utilities.isUserEmployee() ||
                (!Utilities.isUserEmployee() && selectedItem.is_private) ? (
                  <TooltipStyled title="Delete">
                    <span>
                      <Button
                        className="btn-link btn--onlyicon btn btn-secondary"
                        onClick={this.confirmDeletion}
                      >
                        <i className="icon-delete-small" aria-hidden="true" />
                      </Button>
                    </span>
                  </TooltipStyled>
                ) : null}
                <TooltipStyled title="Close">
                  <span>
                    <Button
                      className="btn-link btn--onlyicon btn btn-secondary line-right"
                      onClick={this.handleButtonCloseClick}
                    >
                      <i className="icon-close2" aria-hidden="true" />
                    </Button>
                  </span>
                </TooltipStyled>
              </div>
            </div>
          </div>
        </header>
        <div className="main-sec">
          <div
            className={`left-side-inner-sec no-padding${
              this.state.isManageFilePanelCollapsed ? ' panel-collapsed' : ''
            }`}
          >
            <div
              className="left-inner-content no-shadow no-padding"
              style={{ height: '100%' }}
            >
              {selectedItem.file_type === 'PDF' && isIE ? (
                <PdfViewer file={selectedItem.file_url} fileName={filename} />
              ) : selectedItem.file_type === 'PDF' && !isIE ? (
                <DocumentPDFViewer
                  url={fileUrl}
                  fileName={filename}
                  downloadUrl={url}
                  documentUuid={selectedItem.uuid}
                  isRenaming={this.state.isRenaming}
                />
              ) : (
                <div
                  className="emptyBox text-center"
                  onClick={
                    this.state.isRenaming
                      ? undefined
                      : () => this.downloadAttachement(url)
                  }
                  style={{
                    cursor: this.state.isRenaming ? 'not-allowed' : 'pointer',
                    opacity: this.state.isRenaming ? 0.5 : 1,
                  }}
                >
                  <h3 className="emptyBox-icon text-large">
                    <i className="icon-download2" />{' '}
                    {this.state.isRenaming
                      ? 'Saving rename…'
                      : 'Please download file to view the details.'}
                  </h3>
                </div>
              )}
            </div>
          </div>
          <div
            className={`right-sidebar-inner${
              this.state.isManageFilePanelCollapsed ? ' collapsed' : ''
            }`}
            style={{
              position: 'relative',
              minHeight: '100%',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <button
              type="button"
              className="manage-file-panel-toggle"
              onClick={this.toggleManageFilePanel}
              aria-label={
                this.state.isManageFilePanelCollapsed
                  ? 'Expand Manage File panel'
                  : 'Collapse Manage File panel'
              }
              aria-expanded={!this.state.isManageFilePanelCollapsed}
              title={
                this.state.isManageFilePanelCollapsed
                  ? 'Expand Manage File panel'
                  : 'Collapse Manage File panel'
              }
            >
              <i
                className={
                  this.state.isManageFilePanelCollapsed
                    ? 'icon-chevron-left'
                    : 'icon-chevron-right'
                }
                aria-hidden="true"
              />
            </button>
            {this.state.aiIngestionStatus === 'failed' && (
              <div
                className="alert alert-warning"
                role="alert"
                style={{
                  margin: '0 0 16px 0',
                  fontSize: '14px',
                  borderRadius: '2px',
                  border: '1px solid #ffc107',
                  backgroundColor: '#fff3cd',
                }}
              >
                <div className="d-flex align-items-center">
                  <i
                    className="icon-warning"
                    style={{ marginRight: '8px', fontSize: '16px' }}
                  />
                  <span>
                    AI suggestions couldn’t be loaded because this file type
                    isn’t supported. See supported file types{' '}
                    <a
                      href="https://support.liscio.me/en/articles/12642691-ai-file-intelligence-supported-file-types"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: 'underline', padding: 0 }}
                    >
                      here
                    </a>
                    .
                  </span>
                </div>
              </div>
            )}

            {/* Section 1: Manage File Name */}
            <div
              className="file-management-section"
              // Deterministic naming renders its own card chrome inside
              // DeterministicFileNameManagement; the legacy AI-naming UI does
              // not, so we only apply the outer card styles to the legacy path.
              style={{
                marginBottom: '24px',
                ...(isDeterministicNamingEnabled
                  ? {}
                  : {
                      padding: '16px',
                      border: '1px solid #e9ecef',
                      borderRadius: '4px',
                      backgroundColor: '#fff',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                    }),
              }}
            >
              {!isDeterministicNamingEnabled && (
                <>
                  <h3
                    style={{
                      fontSize: '16px',
                      fontWeight: '600',
                      marginBottom: '8px',
                      color: '#2c3e50',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <i className="icon-edit mr-2" />
                    Manage File Name
                  </h3>
                  <p
                    style={{
                      fontSize: '13px',
                      color: '#6c757d',
                      marginBottom: '16px',
                      marginTop: '0',
                    }}
                  >
                    {isAiRenamingEnabled
                      ? 'AI-powered file naming with suggested names based on your preferences'
                      : 'Edit the file name and view file details'}
                  </p>
                </>
              )}
              {isDeterministicNamingEnabled && selectedItem?.uuid ? (
                <DeterministicFileNameManagement
                  key={selectedItem.uuid}
                  fileUuid={selectedItem.uuid}
                  initialFileName={selectedItem.file_name}
                  fileSize={selectedItem.file_size}
                  uploadedBy={selectedItem.uploaded_by}
                  initialOriginalName={selectedItem.original_name}
                  initialAutoNamed={selectedItem.auto_named}
                  initialSuggestedName={selectedItem.suggested_name}
                  aiIngestionInProgress={this.state.aiIngestionInProgress}
                  isEmployee={Utilities.isUserEmployee()}
                  onboardingSpotlight={this.state.fileRenameSpotlightActive}
                  onOptimisticName={(name) =>
                    this.setState({ optimisticName: name })
                  }
                  onMutatingChange={(isMutating) =>
                    this.setState((prev) => ({
                      isRenaming: isMutating,
                      // Clear the optimistic override when the mutation
                      // settles — onFileRenamed has already moved
                      // selectedItem.file_name to the canonical value, so the
                      // header can read from there again. On rejection, the
                      // child fires onOptimisticName(prevFileName) before
                      // onMutatingChange(false), so optimisticName is the
                      // pre-mutation name at this point — clearing it is
                      // still correct because selectedItem.file_name was
                      // never updated (no applyFileUpdate ran).
                      optimisticName: isMutating ? prev.optimisticName : null,
                    }))
                  }
                  onFileRenamed={(displayName, downloadUrl) => {
                    if (!displayName) return;
                    if (window.PSPDFKIT_INSTANCE) {
                      window.PSPDFKIT_INSTANCE.fileName = displayName;
                    }
                    // Split + sync every legacy field in a single setState.
                    // Calling this.fileExtention() here (which setStates
                    // fileExt/filename itself) produced two sequential
                    // renders in React 17's post-await context — the PDF
                    // viewer on the left flickered as it saw selectedItem
                    // change in one render and name/ext in the next.
                    // handleEditDocumentSubmit (~line 772) builds its
                    // file_name payload from filename + fileExt, so both
                    // must be kept in sync here or the next metadata save
                    // silently reverts the rename.
                    const dot = displayName.lastIndexOf('.');
                    const base =
                      dot > 0 ? displayName.slice(0, dot) : displayName;
                    const ext = dot > 0 ? displayName.slice(dot) : '';
                    this.setState((prevState) => ({
                      selectedItem: {
                        ...prevState.selectedItem,
                        file_name: displayName,
                        doc_name: displayName,
                        auto_named: true,
                        file_download_url:
                          downloadUrl ??
                          prevState.selectedItem.file_download_url,
                      },
                      editedFileName: displayName,
                      filename: base,
                      fileExt: ext,
                      fileRenameSpotlightActive: false,
                      showFileRenameCoachmark: false,
                    }));
                  }}
                />
              ) : isAiRenamingEnabled && selectedItem?.uuid ? (
                <AIFileNameManagement
                  fileUuid={selectedItem.uuid}
                  fileName={selectedItem.file_name}
                  fileSize={selectedItem.file_size}
                  uploadedBy={selectedItem.uploaded_by}
                  originalName={selectedItem.original_name}
                  onChangeFileName={this.handleChangeFileName}
                  aiIngestionStatus={this.state.aiIngestionStatus}
                />
              ) : (
                // Manual file name editing
                <div>
                  <div className="form-group form-inline-label">
                    <Label
                      for="forFileName"
                      className="align-self-start pt-2 mt-1"
                    >
                      File Name
                    </Label>
                    <div className="labelValue">
                      <div
                        className={
                          errors.filename
                            ? 'd-block form-group form-error mb-0'
                            : 'd-block form-group mb-0'
                        }
                      >
                        <input
                          type="text"
                          name="filename"
                          className="form-control"
                          value={filename}
                          onChange={this.handleInputFieldChange}
                          onBlur={this.handleValidation}
                          error={errors.filename}
                          autoComplete="off"
                        />
                        <span
                          className={errors.filename ? 'error_label' : 'd-none'}
                        >
                          {errors.filename}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="form-group form-inline-label">
                    <Label for="forContact">UPLOADED BY</Label>
                    <div className="labelValue">
                      <div className="avatar avatar--w20">
                        {selectedItem.uploader ? (
                          selectedItem.uploader.avatar ? (
                            <img src={selectedItem.uploader.avatar} alt="" />
                          ) : selectedItem.uploader.initials ? (
                            <span className="uName">
                              {selectedItem.uploader.initials}
                            </span>
                          ) : (
                            '-'
                          )
                        ) : (
                          '-'
                        )}
                        <span className="userName">
                          {selectedItem.uploaded_by || '-'}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Section 2: Manage Tags */}
            <div
              className="file-management-section"
              style={{
                marginBottom: '24px',
                padding: '16px',
                border: '1px solid #e9ecef',
                borderRadius: '4px',
                backgroundColor: '#fff',
                boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
              }}
            >
              <h3
                style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  marginBottom: '8px',
                  color: '#2c3e50',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <i className="icon-tag mr-2" />
                Manage Tags
              </h3>
              <Typography
                variant="body2"
                color="text.disabled"
                sx={{ mb: 2, mt: 0, fontStyle: 'italic' }}
              >
                {isAiTaggingEnabled
                  ? 'AI-suggested tags to improve searchability and organization'
                  : 'Select tags from your library to categorize this file'}
              </Typography>
              {isAiTaggingEnabled ? (
                <AITagManagement
                  onChangeTags={this.handleChangeTags}
                  fileId={selectedItem.uuid}
                  tags={
                    selectedItem?.tags?.map((tag) => ({
                      key: tag,
                      label: tag,
                    })) || []
                  }
                  aiIngestionStatus={this.state.aiIngestionStatus}
                />
              ) : (
                <div
                  className={
                    errors.tags
                      ? 'form-group form-inline-label form-error'
                      : 'form-group form-inline-label'
                  }
                >
                  <Label for="forContact" className="align-self-start">
                    Tags
                  </Label>
                  <div className="labelValue">
                    <div className="customTags mailDrodown customTagsDropDown">
                      <div className="customTags__input form-control">
                        {this.renderMultiTags()}
                        <label htmlFor="multitags" className="inputHelper" />
                        <Input
                          type="text"
                          name="multitags"
                          id="multitags"
                          onFocus={this.onMultiTagFocus}
                          onChange={this.changeMultiTagInput}
                          className="dropdown-toggle"
                          placeholder=""
                          value={inputMultiTagVal}
                          autoComplete="off"
                        />
                      </div>
                      {errors.tags ? (
                        <span className="error_label">
                          at least
                          <b className="label-medium"> 1 </b>
                          tag is mandatory
                        </span>
                      ) : null}
                      {this.state.mutiltagdropdownOpen ? (
                        <div className="dropdown-menu show tagsDropDown">
                          <div className="input-group">
                            <input
                              type="text"
                              value={
                                tagId
                                  ? { value: tagId, label: tagName }
                                  : undefined
                              }
                              className="form-control border-0"
                              name="owner"
                              onChange={(e) =>
                                this.filterMultiTagSearch(e.target.value)
                              }
                              id="myInput"
                            />
                            <span className="input-group-addon border-left-0">
                              <i className="icon-zoom2" />
                            </span>
                          </div>
                          {multiTags}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Section 3: Manage File Metadata */}
            <div
              className="file-management-section"
              style={{
                marginBottom: '24px',
                padding: '16px',
                border: '1px solid #e9ecef',
                borderRadius: '4px',
                backgroundColor: '#fff',
                boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
              }}
            >
              <h3
                style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  marginBottom: '8px',
                  color: '#2c3e50',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <i className="icon-save mr-2" />
                Manage File Metadata
              </h3>
              <Typography
                variant="body2"
                color="text.disabled"
                sx={{ mb: 2, mt: 0, fontStyle: 'italic' }}
              >
                View file information and manage year, month, and other metadata
              </Typography>
              <form onSubmit={this.handleEditDocumentSubmit}>
                {Utilities.isUserEmployee() ? (
                  <div className="form-group form-inline-label">
                    <Label for="forContact" className="align-self-start">
                      Associated with
                    </Label>
                    <div className="labelValue">
                      <div className="avatar avatar--w20">
                        {recepent && recepent.length
                          ? recepent.map((each, index) => {
                              if (index < 4) {
                                return (
                                  <TooltipStyled
                                    key={`${each.initials}_${index}`}
                                    title={[each.name, each.account_name]
                                      .filter(Boolean)
                                      .join(' . ')}
                                  >
                                    <div className="avatar avatar--w20 d-inline-block">
                                      {each.name ? (
                                        each.avatar ? (
                                          <img
                                            src={each.avatar}
                                            alt="I"
                                            width="20"
                                            height="20"
                                            className="rounded-circle"
                                          />
                                        ) : (
                                          <span className="uName">
                                            {each.initials}
                                          </span>
                                        )
                                      ) : each.account_name ? (
                                        <span className="uName">
                                          {this.getInitials(each.account_name)}
                                        </span>
                                      ) : (
                                        ''
                                      )}
                                    </div>
                                  </TooltipStyled>
                                );
                              } else if (index === 4) {
                                return (
                                  <div
                                    key={index}
                                    className="dropdown dropdown--small d-inline-block ml-0"
                                  >
                                    <a
                                      href="javascript:"
                                      className="btn p-0 dropdown-toggle border-0"
                                      data-toggle="dropdown"
                                      style={{ lineHeight: '20px' }}
                                    >
                                      <span className="avatar avatar--w30 align-self-center">
                                        <span className="uName">
                                          +{recepent.length - 4}
                                        </span>
                                      </span>
                                      <span className="dropupWrap--caret" />
                                    </a>
                                    <div className="dropdown-menu dropdown-menu-right">
                                      {recepent.map((e, i) => {
                                        if (i >= 4) {
                                          return (
                                            <a
                                              key={recepent.indexOf(e)}
                                              href="javascript:"
                                              className="dropdown-item py-1"
                                            >
                                              <div className="d-flex">
                                                <span className="avatar avatar--w20 align-self-start">
                                                  <span className="uName">
                                                    {e.initials ||
                                                      this.getInitials(
                                                        e.account_name,
                                                      )}
                                                  </span>
                                                </span>
                                                <div className="">
                                                  <h5 className="fontSize letterSpace-1 mb-0">
                                                    {e.name}
                                                  </h5>
                                                  <h4 className="subHeadline text-light letterSpace-1 mb-0">
                                                    {e.account_name}
                                                  </h4>
                                                </div>
                                              </div>
                                            </a>
                                          );
                                        }
                                        return null;
                                      })}
                                    </div>
                                  </div>
                                );
                              }
                              return null;
                            })
                          : '-'}
                        {selectedItem.source === 'Note' ||
                        (selectedItem.source === 'Task' &&
                          selectedItem.task_type_key === 'to_do') ? null : (
                          <div className="mr-2 d-inline-block">
                            <a
                              href="javascript:;"
                              onClick={this.shareFile}
                              className="text-dark fontSize p-0"
                            >
                              <i className="icon-Share text-small mr-2 vertical-middle" />
                              Share
                            </a>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="form-group form-inline-label">
                    <Label for="forContact" className="align-self-start" />
                    <div className="labelValue">
                      <div className="mr-2 d-inline-block">
                        <a
                          href="javascript:;"
                          onClick={this.shareFile}
                          className="text-dark fontSize p-0"
                        >
                          <i className="icon-Share text-small mr-2 vertical-middle" />
                          Share
                        </a>
                      </div>
                    </div>
                  </div>
                )}
                <div className="form-group form-inline-label">
                  <Label for="forContact" className="align-self-start">
                    Source
                  </Label>
                  <div className="labelValue">
                    <span>
                      <a
                        href="javascript:void(0)"
                        className="text-dark"
                        onClick={() => this.redirectLink(selectedItem)}
                      >
                        {source}
                      </a>
                    </span>
                  </div>
                </div>
                <div className="form-group form-inline-label">
                  <Label for="forContact" className="align-self-start">
                    Date Added
                  </Label>
                  <div className="labelValue">
                    <span>{dateAdded}</span>
                  </div>
                </div>
                {!isAiRenamingEnabled && (
                  <div className="form-group form-inline-label">
                    <Label for="forContact" className="align-self-start">
                      Size
                    </Label>
                    <div className="labelValue">
                      <span>{trimSize} KB</span>
                    </div>
                  </div>
                )}
                <div className="form-group form-inline-label">
                  <Label for="forContact" className="align-self-start">
                    Kind
                  </Label>
                  <div className="labelValue">
                    <span>{mime.getExtension(selectedItem.content_type)}</span>
                  </div>
                </div>
                <div className="form-group form-inline-label">
                  <Label
                    for="forContact"
                    className="align-self-start pt-2 mt-1"
                  >
                    Year
                  </Label>
                  <div className="labelValue">
                    <Select
                      id="state-select"
                      className="select-custom-class"
                      onBlurResetsInput={false}
                      onSelectResetsInput={false}
                      options={years}
                      onChange={this.handleYearChange}
                      value={
                        yearId ? { value: yearId, label: yearValue } : null
                      }
                      isClearable={true}
                    />
                  </div>
                </div>
                <div className="form-group form-inline-label">
                  <Label
                    for="forContact"
                    className="align-self-start pt-2 mt-1"
                  >
                    Month
                  </Label>
                  <div className="labelValue">
                    <Select
                      id="state-select"
                      className="select-custom-class"
                      onBlurResetsInput={false}
                      onSelectResetsInput={false}
                      options={months}
                      onChange={this.handleMonthChange}
                      value={
                        monthId ? { value: monthId, label: monthValue } : null
                      }
                      isClearable={true}
                    />
                  </div>
                </div>
                <ExportStatusSection
                  selectedItem={selectedItem}
                  isPollingExportStatus={this.state.isPollingExportStatus}
                  onSharePointExport={() =>
                    this.setState({ sharePointPickerModal: true })
                  }
                  onZapierExport={() =>
                    this.setState({
                      exportModal: true,
                      exportModalInitialApp: 'zapier',
                    })
                  }
                />
                {selectedItem.original_name && (
                  <div className="form-group form-inline-label">
                    <Label
                      for="forContact"
                      className="align-self-start pt-2 mt-1"
                    >
                      Original Name
                    </Label>
                    <div className="labelValue">
                      <span>{selectedItem.original_name}</span>
                    </div>
                  </div>
                )}

                {/* Buttons inside metadata box when AI is enabled */}
                {(isAiRenamingEnabled || isAiTaggingEnabled) && (
                  <div style={{ width: '100%', marginTop: '20px' }}>
                    <div
                      style={{ width: '100%', display: 'flex', gap: '12px' }}
                    >
                      <Button
                        type="submit"
                        className="btn btn-primary"
                        color="primary"
                        style={{ flex: '0 0 auto' }}
                      >
                        Save Changes
                      </Button>
                    </div>
                  </div>
                )}
              </form>
            </div>

            {/* Buttons outside all boxes when AI is disabled - applies to all sections */}
            {!isAiRenamingEnabled && !isAiTaggingEnabled && (
              <form
                onSubmit={this.handleEditDocumentSubmit}
                style={{ width: '100%', marginTop: '20px', padding: '0 16px' }}
              >
                <p
                  style={{
                    fontSize: '12px',
                    color: '#6c757d',
                    marginBottom: '16px',
                    fontStyle: 'italic',
                    marginTop: '0',
                    width: '100%',
                  }}
                >
                  Note: Clicking "Save Changes" will save all your edits
                  including file name, tags, year, and month.
                </p>
                <div style={{ width: '100%', display: 'flex', gap: '12px' }}>
                  <Button
                    type="button"
                    className="btn btn-outline-light"
                    color="primary"
                    onClick={this.handleEditDocumentCancel}
                    style={{ flex: '0 0 auto' }}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    className="btn btn-primary"
                    color="primary"
                    style={{ flex: '0 0 auto' }}
                  >
                    Save Changes
                  </Button>
                </div>
              </form>
            )}

            {/* Show "Go to Dashboard" button when coming from onboarding */}
            {this.state.comingFrom === 'onboarding' && (
              <div
                className="onboarding-dashboard-button"
                data-tour="dashboard-button"
                style={{
                  marginTop: 'auto',
                  paddingTop: '2rem',
                  borderTop: '1px solid #e9ecef',
                  position: 'sticky',
                  bottom: 0,
                  backgroundColor: '#fff',
                  zIndex: 10,
                }}
              >
                <Button
                  className="btn btn-primary btn-block"
                  onClick={this.handleDashboardClick}
                >
                  Go to Dashboard
                </Button>
              </div>
            )}

            {this.state.shareFile && (
              <FilePopup
                shareFile
                sharedFileDetails={[selectedItem]}
                closeModal={this.closeModal}
              />
            )}
            {this.state.exportModal && (
              <ExportModal
                selectedRecords={[selectedItem]}
                initialModal={this.state.exportModalInitialApp}
                closeModal={() => {
                  this.setState({
                    exportModal: false,
                    exportModalInitialApp: null,
                  });
                  // Start polling for export status updates after 5 seconds
                  this.startExportStatusPolling();
                }}
              />
            )}
            {this.state.sharePointPickerModal && (
              <SharePointPicker
                mode="export"
                appKey="sharepoint"
                selectedRecords={[selectedItem]}
                closeModal={() => {
                  this.setState({ sharePointPickerModal: false });
                  // Start polling for export status updates after 5 seconds
                  this.startExportStatusPolling();
                }}
                cancelWidget={() =>
                  this.setState({ sharePointPickerModal: false })
                }
              />
            )}
          </div>
          <ConfirmationModal
            isOpen={deleteConfirmation}
            headerText="Confirm delete of this file"
            messageText={this.state.deleteAlertMessage || ''}
            noBtnClick={() => this.setState({ deleteConfirmation: false })}
            yesBtnClick={() => this.deleteConfirmationModal('delete')}
            yesBtnText="Delete File"
            noBtnText="Cancel"
          />
          <ConfirmationModal
            isOpen={filterStatusModal}
            headerText={`Confirm ${
              filterStatus === 'archive' ? 'unarchiving' : 'archiving'
            } this file`}
            messageText={`Are you sure you want to ${
              filterStatus === 'archive' ? 'unarchive' : 'archive'
            } this file?`}
            noBtnClick={() => this.setState({ filterStatusModal: false })}
            yesBtnClick={() => this.deleteConfirmationModal('filterstatus')}
            yesBtnText={`${
              filterStatus === 'archive' ? 'Unarchive' : 'Archive'
            } File`}
            noBtnText="Cancel"
          />
          <MarkAsReviewedConfirmationModal
            fileUuid={selectedItem.uuid}
            isOpen={markAsReviewedModal}
            onClose={() => this.closeAction()}
          />
        </div>
        {this.state.showMultipleSource && (
          <MultipleSourceModal closeModal={this.closeRedirectModal} />
        )}
        {this.state.showManualSource && (
          <ManualSourceModal
            closeModal={this.closeRedirectModal}
            fileDetails={fileDetails}
          />
        )}
        {this.state.showFileRenameCoachmark &&
          selectedItem?.uuid &&
          selectedItem?.suggested_name && (
            <FileRenameCoachmark
              fileUuid={selectedItem.uuid}
              originalName={
                selectedItem.original_name ||
                selectedItem.doc_name ||
                selectedItem.file_name
              }
              suggestedName={selectedItem.suggested_name}
              onDismiss={this.handleFileRenameCoachmarkDismiss}
              onSpotlight={this.handleFileRenameCoachmarkSpotlight}
            />
          )}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  files: bindActionCreators(UploadFilesActions, dispatch),
});

export default withLDConsumer()(
  withRouter(connect(null, mapDispatchToProps)(withAISettings(DocumentShow))),
);
